<template>
    <div class="aesthetics">
        <div id="view-selection">
            <div id="view-right" class="view cursor"
                 v-bind:class="{ active: activeViewAngle === 'front' }" v-on:click="changeViewAngle('front')">
                <img :src="thumbnail_front">
                <p>View front</p>
            </div>
            <div id="view-top" class="view cursor"
                 v-bind:class="{ active: activeViewAngle === 'back' }" v-on:click="changeViewAngle('back')">
                <img :src="thumbnail_back">
                <p>View back</p>
            </div>
            <div id="view-left" class="view cursor"
                 v-bind:class="{ active: activeViewAngle === 'top' }" v-on:click="changeViewAngle('top')">
                <img :src="thumbnail_top">
                <p>View top</p>
            </div>
        </div>
        <div id="sidebar">
            <div id="sidebar-toggle" v-on:click="toggleSidebar()" class="cursor">
                <i class="fas fa-angle-left" v-if="!sidebarActive"></i>
                <i class="fas fa-angle-right" v-if="sidebarActive"></i>
            </div>
            <div id="sidebar-heading">
                <h3>SUMMARY</h3>
            </div>
            <div id="sidebar-content">
                <ul>
                    <li>
                        Model size
                        <span>{{ $root.$data.aesthetics.model_size.name }}</span>
                    </li>
                    <li>
                        Cabin style
                        <span>{{ $root.$data.aesthetics.cabin_style.name }}</span>
                    </li>
                    <li>
                        Coating
                        <span class="sidebar-color-item"
                              v-bind:style="{background: $root.$data.aesthetics.casco_color.code}"></span>
                    </li>
                    <li>
                        Interiors
                        <span class="sidebar-color-item"
                              v-bind:style="{background: $root.$data.aesthetics.cushion_color.code}"></span>
                    </li>
                </ul>
                <router-link to="/features">Next step <i class="fas fa-angle-right"></i></router-link>
            </div>
        </div>

        <div id="boat-preview">
            <img :src="boat_preview">
        </div>

        <div id="tabs">
            <div class="tab-container">
                <div id="model-size-tab" class="tab" v-if="activeTab === 'model-size'">
                    <div class="close-tab-button cursor" v-on:click="toggleTab('model-size')">
                        <i class="fas fa-times"></i>
                    </div>
                    <div class="tab-inner-container cursor" v-for="model in model_sizes"
                         v-bind:class="{ active: $root.$data.aesthetics.model_size.slug === model.slug }"
                         v-on:click="changeModelSize(model)">
                        <div class="un-skewed">
                            <h3 class="tab-inner-container-title">{{ model.name }}</h3>
                            <div class="tab-inner-half">
                                <img :src="model.image" class="boat-image">
                            </div>
                            <div class="tab-inner-half">
                                <p>
                                    {{ model.specs[0] }}<br>
                                    {{ model.specs[1] }}<br>
                                    {{ model.specs[2] }}<br>
                                    {{ model.specs[3] }}<br>
                                    {{ model.specs[4] }}<br>
                                    {{ model.specs[5] }}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="tab-container">
                <div id="cabin-style-tab" class="tab" v-if="activeTab === 'cabin-style'">
                    <div class="close-tab-button cursor" v-on:click="toggleTab('cabin-style')">
                        <i class="fas fa-times"></i>
                    </div>
                    <div class="tab-inner-container cursor" v-for="cabin in cabin_styles"
                         v-bind:class="{ active: $root.$data.aesthetics.cabin_style.slug === cabin.slug }"
                         v-on:click="changeCabinStyle(cabin)"
                         v-if="!($root.$data.aesthetics.model_size.slug === 'damsko-1000' && cabin.slug === 'semiopen')">
                        <div class="un-skewed">
                            <h3 class="tab-inner-container-title">{{ cabin.name }}</h3>
                            <div class="tab-inner-half">
                                <img :src="cabin.image" class="boat-image">
                            </div>
                            <div class="tab-inner-half">
                                <p>
                                    {{ cabin.specs[0] }}<br>
                                    {{ cabin.specs[1] }}<br>
                                    {{ cabin.specs[2] }}<br>
                                    {{ cabin.specs[3] }}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="tab-container">
                <div id="casco-tab" class="tab" v-if="activeTab === 'casco'">
                    <div class="close-tab-button cursor" v-on:click="toggleTab('casco')">
                        <i class="fas fa-times"></i>
                    </div>
                    <div class="color-picker-item cursor" v-for="color in casco_colors">
                        <div class="color-container" v-bind:style="{ background: color.code }"
                             v-bind:class="{ active: $root.$data.aesthetics.casco_color.slug === color.slug }"
                             v-on:click="changeCasco(color)"></div>
                        <p class="un-skewed">
                            {{ color.name }}
                        </p>
                    </div>
                </div>
            </div>

            <div class="tab-container">
                <div id="cushion-tab" class="tab" v-if="activeTab === 'cushion'">
                    <div class="close-tab-button cursor" v-on:click="toggleTab('cushion')">
                        <i class="fas fa-times"></i>
                    </div>
                    <div class="color-picker-item" v-for="color in cushion_colors">
                        <div class="color-container cursor" v-bind:style="{ background: color.code }"
                             v-bind:class="{ active: $root.$data.aesthetics.cushion_color.slug === color.slug }"
                             v-on:click="changeCushion(color)"></div>
                        <p class="un-skewed">
                            {{ color.name }}
                        </p>
                    </div>
                </div>
            </div>

            <div id="tab-buttons">
                <a v-on:click="toggleTab('model-size')" class="button button-skewed cursor"><span>Model size</span></a>
                <a v-on:click="toggleTab('cabin-style')"
                   class="button button-skewed cursor"><span>Deck style</span></a>
                <a v-on:click="toggleTab('casco')" class="button button-skewed cursor"><span>Casco</span></a>
                <a v-on:click="toggleTab('cushion')" class="button button-skewed cursor"><span>Cushion</span></a>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>

    #boat-preview {
        max-height: calc(100vh - 51px);
        img {
            position: fixed;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 100%;
            z-index: -9999;
            /*max-height: calc(100vh - 51px);*/
        }
    }

    #view-selection {
        position: absolute;
        top: 50%;
        left: 50px;
        transform: translate(0, -50%);

        .view {
            margin: 25px 0;

            img {
                width: 80px;
                transform: skew(-7deg);
                border: 1px solid black;
                padding: 10px;
                margin-left: 10px;
                background: white;
                transition: border-width 0.1s, padding 0.1s;
            }
        }

        .view.active {
            img {
                border-bottom: 3px solid #D0021B !important;
                padding-bottom: 8px;
            }
        }

        p {
            margin-top: 8px;
            font-size: 11px;
            text-align: center;
        }
    }

    #sidebar {
        width: 450px;
        background: white;
        position: fixed;
        display: block;
        right: -450px;
        top: 50%;
        transform: translate(0, -50%);
        transition: right 0.5s;
        border-radius: 50px 0 0 0;

        #sidebar-overlay {
            position: absolute;
            top: 52px;
            left: 0;
            width: 450px;
            height: 330px;
            background: rgba(0, 0, 0, 0.7);
            z-index: 1000;
            p {
                text-align: center;
                margin-top: 120px;
                color: white;
                font-size: 0.4rem;
            }
        }

        #sidebar-toggle {
            position: absolute;
            width: 60px;
            left: -60px;
            top: 160px;
            background: rgba(0, 0, 0, 0.7);
            color: white;
            text-align: center;
            i {
                padding: 11px 8px;
                font-size: 40px;
            }
        }

        #sidebar-heading {
            background: black;
            padding: 15px 0;
            text-align: center;
            transform: skew(-7deg);
            margin-left: 3px;
            h3 {
                transform: skew(7deg);
                font-family: "Roboto", sans-serif;
                font-weight: 500;
                color: white;
            }
        }

        #sidebar-content {
            margin: 20px 40px;
            padding-bottom: 40px;
            ul {
                li {
                    list-style: none;
                    display: block;
                    margin: 10px 0;
                    padding: 11px 0;
                    border-bottom: 1px solid rgba(0, 0, 0, 0.4);

                    span {
                        float: right;
                    }

                    .sidebar-color-item {
                        width: 28px;
                        height: 25px;
                        transform: skew(-7deg);
                        border: 1px solid black;
                        margin-right: 30px;
                    }
                }
            }

            a {
                color: #000;
                float: right;
                margin-top: 20px;

                i {
                    padding-left: 20px;
                }
            }
        }
    }

    .aesthetics {
        position: relative;
        padding-top: 51px;
        height: 100vh;
        background: linear-gradient(rgba(0, 0, 0, 0), rgba(52, 52, 52, 0.37));
        ul {
            list-style: none;
            li {
                display: inline;
            }
        }
    }

    #tab-buttons {
        display: flex;
        justify-content: center;
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        .button-skewed {
            margin: 0 10px;
            padding: 10px 0;
            min-width: 160px;
        }
    }

    .tab-container {
        width: 100%;
        display: flex;
        justify-content: center;
    }

    .tab {
        display: flex;
        justify-content: center;
        align-items: center;
        transform: skew(-7deg);
        background: rgba(0, 0, 0, 0.05);
        padding: 10px 20px;
        position: absolute;
        min-height: 165px;
        min-width: 676px;
        bottom: 35px;
        margin: 0 auto;
        font-size: 11px;

        .tab-inner-container {
            margin: 20px 10px;
            padding: 15px;
            background: white;
            text-align: center;
            .tab-inner-half {
                display: inline-block;
                width: 50%;
            }
        }
        .tab-inner-container.active {
            border-bottom: 3px solid #D0021B !important;
            padding-bottom: 12px !important;
        }

        .tab-inner-container-title {
            text-transform: uppercase;
            margin: 10px 0;
            text-align: left;
            padding-left: 40px;
            font-size: 15px;
        }

        .un-skewed {
            transform: skew(7deg);
        }

        .close-tab-button {
            width: 20px;
            height: 20px;
            position: absolute;
            top: 10px;
            right: 10px;
        }
    }

    .boat-image {
        float: left;
        height: 50px;
    }

    .color-picker-item {
        margin: 10px 10px;

        .color-container {
            width: 50px;
            height: 40px;
            margin: 10px 0;
            box-shadow: 2px 2px 2px #333333;
            transition: border-width 0.1s, border-color 0.1s;
        }
        .color-container.active {
            border-bottom: 3px solid #D0021B !important;
        }
        p {
            font-size: 11px;
            text-align: center;
        }
    }

</style>

<script>
    // @ is an alias to /src
    export default {
        name: 'aesthetics',
        components: {},
        data: function () {
            return {
                itemsSelected: false,
                activeTab: 'none',
                sidebarActive: false,
                activeViewAngle: 'front',

                dummy_boat: 'img/dummy1.png',
                thumbnail_front: 'img/aesthetics/batch1_f1f0ea/damsko_750_open/damsko_750_open_f1f0ea_cream_front.png',
                thumbnail_back: 'img/aesthetics/batch1_f1f0ea/damsko_750_open/damsko_750_open_f1f0ea_cream_back.png',
                thumbnail_top: 'img/aesthetics/batch1_f1f0ea/damsko_750_open/damsko_750_open_f1f0ea_cream_top.png',

                boat_preview: 'img/aesthetics/batch1_f1f0ea/damsko_750_open/damsko_750_open_f1f0ea_cream_front.png',

                model_sizes: require('../assets/json/aesthetics/model_sizes'),
                cabin_styles: require('../assets/json/aesthetics/cabin_styles'),
                casco_colors: require('../assets/json/aesthetics/casco_colors'),
                cushion_colors: require('../assets/json/aesthetics/cushion_colors'),

                changedOnce: [false, false, false, false, true]
            }
        },
        mounted: function () {
            this.updatePreview();
        },

        methods: {
            toggleTab: function (tabName) {
                if (this.activeTab === tabName) {
                    this.activeTab = "none";
                } else {
                    this.activeTab = tabName;
                }
            },
            toggleSidebar: function () {
                if (this.sidebarActive === true) {
                    this.sidebarActive = false;
                    document.getElementById('sidebar').style.right = '-450px';
                } else {
                    this.sidebarActive = true;
                    document.getElementById('sidebar').style.right = '-3px';
                }
            },
            changeViewAngle: function (viewAngle) {
                this.activeViewAngle = viewAngle;
                this.updatePreview();
            },
            changeModelSize: function (model) {
                if ('damsko'+this.$root.$data.features.engine.model !== this.$root.$data.aesthetics.model_size.slug) {
                    this.$root.$data.features.engine = '';
                }
                this.changedOnce[0] = true;
                this.checkChangedOnce();
                this.$root.$data.aesthetics.model_size = model;
                this.updatePreview();
            },
            changeCabinStyle: function (cabinStyle) {
                this.changedOnce[1] = true;
                this.checkChangedOnce();
                this.$root.$data.aesthetics.cabin_style = cabinStyle;
                this.updatePreview();
            },
            changeCasco: function (casco) {
                this.changedOnce[2] = true;
                this.checkChangedOnce();
                this.$root.$data.aesthetics.casco_color = casco;
                this.updatePreview();
            },
            changeCushion: function (cushion) {
                this.changedOnce[3] = true;
                this.checkChangedOnce();
                this.$root.$data.aesthetics.cushion_color = cushion;
                this.updatePreview();
            },
            updatePreview: function () {
                this.checkSemiOpen();
                let batch = this.$root.$data.aesthetics.casco_color.slug;
                let model = this.$root.$data.aesthetics.model_size.name.replace(' ', '_');
                let cabin_style = this.$root.$data.aesthetics.cabin_style.slug;
                let casco = this.$root.$data.aesthetics.casco_color.code.replace('#', '');
                let cushion = this.$root.$data.aesthetics.cushion_color.slug;
                let view = this.activeViewAngle;
                this.boat_preview = 'img/aesthetics/' + batch + '_' + casco + '/' + model + '_'
                    + cabin_style + '/' + model + '_' + cabin_style + '_' + casco + '_'
                    + cushion + '_' + view + '.png';
                this.boat_preview = this.boat_preview.toLowerCase();
                this.$root.$data.aesthetics.image = 'img/aesthetics/' + batch + '_' + casco + '/' + model + '_'
                    + cabin_style + '/' + model + '_' + cabin_style + '_' + casco + '_'
                    + cushion + '_front.png';
                this.$root.$data.aesthetics.image = this.$root.$data.aesthetics.image.toLowerCase();
                this.updateThumbnails(this.boat_preview);
            },
            updateThumbnails: function (preview_image) {
                this.thumbnail_front = preview_image.replace(this.activeViewAngle, 'front');
                this.thumbnail_back = preview_image.replace(this.activeViewAngle, 'back');
                this.thumbnail_top = preview_image.replace(this.activeViewAngle, 'top');
            },
            checkSemiOpen: function () {
                if (this.$root.$data.aesthetics.cabin_style.slug === 'semiopen'
                    && this.$root.$data.aesthetics.model_size.slug === 'damsko-1000') {
                    this.$root.$data.aesthetics.cabin_style.name = 'Opened';
                    this.$root.$data.aesthetics.cabin_style.slug = 'open';
                }
                this.$forceUpdate();
            },
            checkChangedOnce: function () {
                if (this.changedOnce[0]
                    && this.changedOnce[1]
                    && this.changedOnce[2]
                    && this.changedOnce[3]
                    && this.changedOnce[4]) {
                    this.toggleSidebar();
                    this.changedOnce[4] = false;
                }
            }
        }
    }
</script>
